import { ButtonProps } from '@rover/kibble/core';
import { getIconComponent } from '@rover/react-lib/src/utils/getIconComponent';
import type { ButtonBh } from '@rover/rsdk/src/apiClient/latest/model/buttonBh';

type BhCtaButtonIconProps = Pick<ButtonProps, 'icon' | 'iconAlignment'>;

export const getBhCtaButtonIconProps = (cta: ButtonBh): BhCtaButtonIconProps => {
  if (!cta?.icon) return {};

  return {
    icon: getIconComponent(cta.icon),
    iconAlignment: 'right',
  };
};
